import { render } from "./LabResultsEntry.vue?vue&type=template&id=0c346afd&scoped=true"
import script from "./LabResultsEntry.vue?vue&type=script&lang=js"
export * from "./LabResultsEntry.vue?vue&type=script&lang=js"

import "./LabResultsEntry.vue?vue&type=style&index=0&id=0c346afd&lang=css"
import "./LabResultsEntry.vue?vue&type=style&index=1&id=0c346afd&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/HMS-MAIN/PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c346afd"]])

export default __exports__